module.exports = __webpack_public_path__ + "img/guigeliao8.d2801c60.jpg";